import React, { Component } from 'react';
import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { cancelRequestJoinEvent, closeCancelRequestEventPopUp } from './actions';

class CancelRequestEventPopUp extends Component {
  constructor(props) {
    super(props);
    this.cancelRequestJoinEvent = this.cancelRequestJoinEvent.bind(this);
  }

  cancelRequestJoinEvent() {
    this.props.cancelRequestJoinEvent(this.props.eventId);
  }

  render() {
    return (
      <Modal
        size='sm'
        backdrop={true}
        keyboard={false}
        show={this.props.show}
        onHide={this.props.closeCancelRequestEventPopUp}
        className="confirm-popup"
      >
        <div className="text-center message">このイベントへの参加希望を取り消しますか？</div>
        <div>
          <button onClick={this.props.closeCancelRequestEventPopUp}>いいえ</button>
          <button onClick={this.cancelRequestJoinEvent}>はい</button>
        </div>
      </Modal>
    );
  }
}

CancelRequestEventPopUp.propTypes = {
  eventId: PropTypes.string,
  show: PropTypes.bool,
  cancelRequestJoinEvent: PropTypes.func,
  closeCancelRequestEventPopUp: PropTypes.func
};

const mapStateToProps = state => {
  return {
    eventId: state.get('eventDetail').get('eventInfo').objectId,
    show: state.get('cancelRequestEventPopUp').get('show')
  };
};

const mapDispatchToProps = dispatch => ({
  cancelRequestJoinEvent: (eventId) => dispatch(cancelRequestJoinEvent(eventId)),
  closeCancelRequestEventPopUp: () => dispatch(closeCancelRequestEventPopUp())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withImmutablePropsToJS(CancelRequestEventPopUp));
